// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38XaW","content":"styles_content__uLQQm"};